module.exports = __webpack_public_path__ + "927740caf0f19e0d4b634896b2c7087a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/cloak-king-s.png
// module id = 1257
// module chunks = 0